import React from "react";
import { NavLink } from "react-router-dom";

function Sidebar({ user, match }) {
  return (
    <nav
      id="sidebarMenu"
      className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse"
      style={{ marginTop: ".5%" }}
    >
      <div className="sidebar-sticky pt-3">
        <ul className="nav flex-column">
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/admin/dashboard"
              activeClassName="active"
            >
              <i className="fas fa-home"></i> Dashboard
            </NavLink>
          </li>
          {user && user.role !== "location" && user.role !== "api-access" && (
            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/admin/profile"
                activeClassName="active"
              >
                <i className="far fa-user"></i> Profile
              </NavLink>
            </li>
          )}
          {user && user.role !== "api-access" && (
            <>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/my-locations"
                  activeClassName="active"
                >
                  <i className="fas fa-map-marker-alt"></i> My Locations
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/help"
                  activeClassName="active"
                >
                  <i className="fa fa-question-circle"></i> Support
                </NavLink>
              </li>
            </>
          )}
          {user && (user.role === "admin" || user.role === "super-admin") && (
            <>
              <h3 className="d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>Admin</span>
              </h3>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/locations"
                  activeClassName="active"
                >
                  <i className="fas fa-map"></i> Locations
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/rounds"
                  activeClassName="active"
                >
                  <i className="far fa-bell"></i> Rounds
                </NavLink>
              </li>
            </>
          )}
        </ul>
        {user && user.role === "super-admin" && (
          <>
            <h3 className="d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>Super Admin</span>
            </h3>

            <ul className="nav flex-column mb-2">
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/users"
                  activeClassName="active"
                >
                  <i className="fas fa-users"></i> Users
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/logs"
                  activeClassName="active"
                >
                  <i className="fas fa-globe"></i> Logs
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/releases"
                  activeClassName="active"
                >
                  <i className="fas fa-rss"></i> Releases
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/system"
                  activeClassName="active"
                >
                  <i className="fa fa-desktop"></i> System
                </NavLink>
              </li>
            </ul>
          </>
        )}
      </div>
    </nav>
  );
}

export default Sidebar;
